
import {Component, Vue, Prop} from "vue-property-decorator";
import {Getter} from "vuex-class";
import router from "@/router";

@Component
export default class KeyRetrieve extends Vue {

    @Prop({default: {}})
    public currentKey: any;

    @Prop({default: false})
    public disabled: boolean;

    @Getter private currentUser: any;
    @Getter private canDoInEnvCompany: (right: string) => boolean;
    @Getter private isMobile: boolean;

    private retrieveDialog: boolean = false;
    private confirmRetrieve: boolean = false;
    private loading: boolean = false;

    get canRetrieveKey(): boolean {
        return !this.currentUserHasKey
            && !this.isKeyInRelay
            && (!this.isKeyInConnectedBox
              || (this.canDoInEnvCompany("RETRIEVE_KEY_CONNECTED_BOX") && this.isManager)
            );
    }

    // check if one of the user of one of the management groups match the current user
    get isManager(): boolean {
      return !!this.currentKey?.legitimateKeyAccess?.keyManagementId;
    }

    get currentUserHasKey(): boolean {
        return this.currentKey?.KeyHolding?.find((kH) => !kH.endDate)?.userId === this.currentUser?.id;
    }

    get isKeyInRelay(): boolean {
        return this.currentKey?.status === "IN_RELAY";
    }

    get currentLocation() {
        return this.currentKey?.KeyLocation?.find((kL) => !kL.endDate)?.Location;
    }

    get isKeyInConnectedBox(): boolean {
        return !!this.currentLocation?.Box?.ConnectedBox;
    }

    private retrieveKey() {
        this.loading = true;
        this.$store.dispatch("keys/retrieve", {
            keyId: this.currentKey.id,
            userId: this.currentUser.id,
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
                icon: "icon-picto_rapatrier",
                msg: this.$i18n?.t("alerts.key.retrieveSuccess", {key: this.currentKey.name}),
            });
            this.keyRetrieveDone();
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", {
              error,
              icon: "icon-picto_rapatrier",
            });
        }).finally(() => {
            this.loading = false;
        });
    }

    private keyRetrieveDone() {
        this.$store.dispatch("context/clearContext");
        this.retrieveDialog = false;
        this.$emit("reset");
    }
}
